import { render, staticRenderFns } from "./HelpFaq.vue?vue&type=template&id=198dac49&scoped=true"
import script from "./HelpFaq.vue?vue&type=script&lang=js"
export * from "./HelpFaq.vue?vue&type=script&lang=js"
import style0 from "./HelpFaq.vue?vue&type=style&index=0&id=198dac49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198dac49",
  null
  
)

export default component.exports